export const getImage = (url) => {
  if (url.includes('store')) {
    return 'https://cdn.grofers.com/assets/ui/blinkit_store.png';
  }

  return url;
};

// Create a custom div overlay for the label
export function createHomeLabelOverlay(position, map) {
  function HomeLabelOverlay(position, map) {
    this.position = position;
    this.map = map;
    this.div = null;
    this.setMap(map);
  }

  HomeLabelOverlay.prototype = new window.google.maps.OverlayView();

  HomeLabelOverlay.prototype.onAdd = function () {
    const div = document.createElement('div');
    div.style.position = 'absolute';
    div.style.transform = 'translate(-50%, -100%)';
    div.style.padding = '2px 10px';
    div.style.border = '2px solid #4285F4';
    div.style.borderRadius = '4px';
    div.style.background = '#E3F0FB';
    div.style.color = '#4285F4';
    div.style.fontSize = '14px';
    div.style.fontWeight = '500';
    div.style.whiteSpace = 'nowrap';
    div.style.boxShadow = 'none';
    div.innerText = 'No Delivery Pin Order';
    this.div = div;
    const panes = this.getPanes();
    panes.overlayImage.appendChild(div);
  };

  HomeLabelOverlay.prototype.draw = function () {
    if (!this.div) return;
    const overlayProjection = this.getProjection();
    const pos = overlayProjection.fromLatLngToDivPixel(
      new window.google.maps.LatLng(
        this.position.latitude,
        this.position.longitude,
      ),
    );
    if (pos) {
      this.div.style.left = pos.x + 'px';
      this.div.style.top = pos.y - 40 + 'px'; // 40px above the marker/circle
    }
  };

  HomeLabelOverlay.prototype.onRemove = function () {
    if (this.div) {
      this.div.parentNode.removeChild(this.div);
      this.div = null;
    }
  };

  return new HomeLabelOverlay(position, map);
}
